import {createSelector} from 'reselect';

// Executions redux state
const executionsReducerSelector = state => { 
    return state.executions;
};

// Executions List
const executionsSelector = createSelector(
    executionsReducerSelector,
    executionsReducer => executionsReducer.get('payload')
);

// Executions is fetching
const executionsIsFetchingSelector = createSelector(
    executionsReducerSelector,
    executionsReducer => executionsReducer.get('isFetching')
);

// Executions error
const executionsErrorSelector = createSelector(
    executionsReducerSelector,
    executionsReducer => executionsReducer.get('error')
);

export {
    executionsSelector,
    executionsIsFetchingSelector,
    executionsErrorSelector
};